//存储LocalStorage
const setStore = (key, content) => {
    if (!key) return;
    localStorage.setItem(key, JSON.stringify(content));
};
//得到LocalStorage
const getStore = key => {
    if (!key) return;
    return JSON.parse(localStorage.getItem(key));
};
//删除LocalStorage
const removeStore = key => {
    if (!key) return;
    localStorage.removeItem(key);
};

export default {
    setStore,getStore,removeStore
}
